import React, { useState,useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import {FaHome} from 'react-icons/fa';
import {IoIosArrowForward} from 'react-icons/io';
import {BsTelephoneInbound} from 'react-icons/bs';
import {AiFillDollarCircle} from 'react-icons/ai';
import {MdBedroomParent} from 'react-icons/md';
import {BiTask} from 'react-icons/bi';
import {IoChevronForwardCircle} from 'react-icons/io5';
import {AiFillPlusCircle} from 'react-icons/ai';
import {BsThreeDots} from 'react-icons/bs';
import {AiTwotoneStar} from 'react-icons/ai';
import { NavLink } from 'react-router-dom';
import ProgressBar from '../ProgressBar';
import Aos from "aos";
import "aos/dist/aos.css";

import './Dashboard.css';


const testData = [
    { bgcolor: "#fff", completed: 60 ,basebgcolor:' #808080'},
    { bgcolor: "#fff", completed: 30 ,basebgcolor:' #808080' },
    { bgcolor: "#fff", completed: 53 ,basebgcolor:' #808080'},
    { bgcolor: "#fff", completed: 23 ,basebgcolor:' #808080'},
    { bgcolor: "#3399ff", completed: 72 ,basebgcolor:'#d9d9d9' },
    { bgcolor: "#ffbf80", completed: 15 ,basebgcolor:'#d9d9d9' },
    { bgcolor: "#ff1ab3", completed: 50 ,basebgcolor:'#d9d9d9' },
    { bgcolor: "#3399ff", completed: 22 ,basebgcolor:'#d9d9d9' },
    { bgcolor: "#ffbf80", completed: 5 ,basebgcolor:'#d9d9d9' },
    { bgcolor: "#ff1ab3", completed: 18 ,basebgcolor:'#d9d9d9' },
    { bgcolor: "#3399ff", completed: 60 ,basebgcolor:'#d9d9d9' },
    { bgcolor: "#ffbf80", completed: 2 ,basebgcolor:'#d9d9d9' },
    { bgcolor: "#ff1ab3", completed: 38 ,basebgcolor:'#d9d9d9' }
  ];

const userData=[
    {avatar:'MK',name:'Mukesh Kumar',email:'MukeshK@gmail.com'},
    {avatar:'AJ',name:'Avinask john',email:'avainashj@gmail.com'},
    {avatar:'VP',name:'Vincent Patrick',email:'VincentPat@gmail.com'},
    {avatar:'PD',name:'Prabhu Dev',email:'PrabhuDK@gmail.com'}
]
const reviewData=[
    {avatar:'VK',name:'Vinod Kumar',email:'VinodK@gmail.com',stars:'4',message:'Very professional staff'},
    {avatar:'SR',name:'Sushita Reddy',email:'SushitaRj@gmail.com',stars:'3',message:'Decsent environement but could improve food menu'},
    {avatar:'VP',name:'Vincent Patrick',email:'VincentPat@gmail.com',stars:'4',message:'Very comfortable beds,looking forward to visit again'},
    {avatar:'GN',name:'Guru Northan',email:'GuruN@gmail.com',stars:'5',message:'Real definition of perfection'}
]






function Dashboard(props) {
    const [Pvalue,setPvalue]= useState('30');

    function handleChange(e){
        const NewVal= e.target.value;
       return setPvalue(NewVal);
    }
    function reviewStars(num) {
        let stars = [];
        for(let i= 0; i < num; i++) {
          stars.push( <AiTwotoneStar key={i} />);
        }
        return (
          <div>{stars}</div>
        );
      };

      useEffect(() => {
        window.scroll(0,0)
        Aos.init({duration:2000});
      }, []);
    
    
    return (
        <div >
             <div className={props.isOpen?'view22':'view11'}>
             
                <div className='DashboardHeader'>
                    <div className='pull-left'>
                        <div className='page-title'>Dashboard</div>
                    </div>
                    
                    <ol className='pull-right'>
                        <li style={{display:'inline-block'}}>
                            <FaHome style={{verticalAlign:'text-top'}} />
                            <NavLink className='dashLink' to='/admin/dashboard' style={{verticalAlign:'center'}}> Home</NavLink>
                            <IoIosArrowForward style={{verticalAlign:'text-bottom'}} />
                        </li>
                        <li active >Dashboard</li>
                        
                    </ol>
                </div>
                <div className='contenu'>
                    <Row>
                    <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                        <div className='info-box bg-orange'>
                                <span className='info-box-icon'>
                                    <BiTask  className='occupancyIcon' />
                                </span>
                                <div className='info-box-content'>
                                <span className='info-box-text'>Total Booking</span>
                                <span className='info-box-number'>15</span>
                                <div >
                                    
                                    <div className='show-add-room-box total-booking'>
                                    <div style={{paddingLeft:'5px',paddingRight:'5px'}}>
                                        {
                                        <ProgressBar bgcolor={testData[1].bgcolor} basebgcolor={testData[1].basebgcolor} completed={testData[1].completed} />
                                        }
                                    </div>
                                    
                                    <div className='show-room-box'>
                                        <span className='show-title'>Show</span>
                                        <IoChevronForwardCircle className='fIcon' />
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </Col>
                        <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                            <div className='info-box bg-blue'>
                                <span className='info-box-icon'>
                                    <MdBedroomParent  className='occupancyIcon' />
                                </span>
                                <div className='info-box-content'>
                                <span className='info-box-text'>Available Rooms</span>
                                <span className='info-box-number'>25</span>
                                <div className='show-add-room-box'>
                                    <div className='show-room-box'>
                                        <span className='show-title'>Show</span>
                                        <IoChevronForwardCircle className='fIcon' />
                                    </div>
                                    <div className='show-room-box'>
                                        <span className='show-title'>Add</span>
                                        <AiFillPlusCircle className='fIcon' />
                                    </div>
                                </div>
                            </div>
                            </div>
                           
                            
                        </Col>
                        
                        <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                        <div className='info-box bg-violet'>
                                <span className='info-box-icon'>
                                    <BsTelephoneInbound className='occupancyIcon' />
                                </span>
                                <div className='info-box-content'>
                                <span className='info-box-text'>Inquiry</span>
                                <span className='info-box-number'>34</span>
                                <div >
                                <div className='show-add-room-box total-booking'>
                                    <div style={{paddingLeft:'5px',paddingRight:'5px'}}>
                                        {
                                        <ProgressBar bgcolor={testData[2].bgcolor} basebgcolor={testData[2].basebgcolor} completed={testData[2].completed} />
                                        }
                                    </div>
                                    
                                    <div className='show-room-box'>
                                        <span className='show-title'>Show</span>
                                        <IoChevronForwardCircle className='fIcon' />
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </Col>
                        <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                        <div className='info-box bg-green'>
                                <span className='info-box-icon'>
                                    <AiFillDollarCircle className='occupancyIcon' />
                                </span>
                                <div className='info-box-content'>
                                <span className='info-box-text'>Total Earning</span>
                                <span className='info-box-number'>1lahk</span>
                                <div >
                                <div className='show-add-room-box total-booking'>
                                    <div style={{paddingLeft:'5px',paddingRight:'5px'}}>
                                        {
                                        <ProgressBar bgcolor={testData[3].bgcolor} basebgcolor={testData[3].basebgcolor} completed={testData[3].completed} />
                                        }
                                    </div>
                                    
                                    <div className='show-room-box'>
                                        <span className='show-title'>Show</span>
                                        <IoChevronForwardCircle className='fIcon' />
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <div className='card card-bordered card-full'>
                            <div className='card-inner d-flex flex-column h-100'>
                                <div className='card-title-group mb-3'>
                                    <div className='card-title'>
                                        <h6 className='ctitle'>Top Selected Room Types</h6>
                                        <p>In the last {Pvalue} days top selected room types.</p>
                                    </div>
                                    <div className='card-tools mt-n1 mr-n1'>
                                       {/* <Select options={options} /> */}
                                       <select value={Pvalue} onChange={handleChange} >
                                           <option value='30'>30</option>
                                           <option value='15'>15</option>
                                           <option value='7'>7</option>
                                       </select>

                                    </div>
                                </div>
            {/* month period */}
                                <div className={Pvalue==='30'?'progress-list gy-3':'invis'}>
                                    <div className='progress-wrap'>
                                        <div className='progress-text'>
                                            <div className='progress-label'>Luxury Room</div>
                                            <div className='progress-amount'>{testData[4].completed}%</div>
                                        </div>
                                        <div>
                                                {
                                                    <ProgressBar bgcolor={testData[4].bgcolor} basebgcolor={testData[4].basebgcolor} completed={testData[4].completed} />
                                                }
                                        </div>
                                    </div>
                                    <div className='progress-wrap'>
                                        <div className='progress-text'>
                                            <div className='progress-label'>Delux Suite</div>
                                            <div className='progress-amount'>{testData[5].completed}%</div>
                                        </div>
                                        <div>
                                                {
                                                    <ProgressBar bgcolor={testData[5].bgcolor} basebgcolor={testData[5].basebgcolor} completed={testData[5].completed} />
                                                }
                                        </div>
                                    </div>
                                    <div className='progress-wrap'>
                                        <div className='progress-text'>
                                            <div className='progress-label'>Premium Suite</div>
                                            <div className='progress-amount'>{testData[6].completed}%</div>
                                        </div>
                                        <div>
                                                {
                                                    <ProgressBar bgcolor={testData[6].bgcolor} basebgcolor={testData[6].basebgcolor} completed={testData[6].completed} />
                                                }
                                        </div>
                                    </div>
                                </div>
                {/* half month period */}
                                <div className={Pvalue==='15'?'progress-list gy-3':'invis'}>
                                    <div className='progress-wrap'>
                                        <div className='progress-text'>
                                            <div className='progress-label'>Luxury Room</div>
                                            <div className='progress-amount'>{testData[7].completed}%</div>
                                        </div>
                                        <div>
                                                {
                                                    <ProgressBar bgcolor={testData[7].bgcolor} basebgcolor={testData[7].basebgcolor} completed={testData[7].completed} />
                                                }
                                        </div>
                                    </div>
                                    <div className='progress-wrap'>
                                        <div className='progress-text'>
                                            <div className='progress-label'>Delux Suite</div>
                                            <div className='progress-amount'>{testData[8].completed}%</div>
                                        </div>
                                        <div>
                                                {
                                                    <ProgressBar bgcolor={testData[8].bgcolor} basebgcolor={testData[8].basebgcolor} completed={testData[8].completed} />
                                                }
                                        </div>
                                    </div>
                                    <div className='progress-wrap'>
                                        <div className='progress-text'>
                                            <div className='progress-label'>Premium Suite</div>
                                            <div className='progress-amount'>{testData[9].completed}%</div>
                                        </div>
                                        <div>
                                                {
                                                    <ProgressBar bgcolor={testData[9].bgcolor} basebgcolor={testData[9].basebgcolor} completed={testData[9].completed} />
                                                }
                                        </div>
                                    </div>
                                </div>
            {/* week period */}
                                <div className={Pvalue==='7'?'progress-list gy-3':'invis'}>
                                    <div className='progress-wrap'>
                                        <div className='progress-text'>
                                            <div className='progress-label'>Luxury Room</div>
                                            <div className='progress-amount'>{testData[10].completed}%</div>
                                        </div>
                                        <div>
                                                {
                                                    <ProgressBar bgcolor={testData[10].bgcolor} basebgcolor={testData[10].basebgcolor} completed={testData[10].completed} />
                                                }
                                        </div>
                                    </div>
                                    <div className='progress-wrap'>
                                        <div className='progress-text'>
                                            <div className='progress-label'>Delux Suite</div>
                                            <div className='progress-amount'>{testData[11].completed}%</div>
                                        </div>
                                        <div>
                                                {
                                                    <ProgressBar bgcolor={testData[11].bgcolor} basebgcolor={testData[11].basebgcolor} completed={testData[11].completed} />
                                                }
                                        </div>
                                    </div>
                                    <div className='progress-wrap'>
                                        <div className='progress-text'>
                                            <div className='progress-label'>Premium Suite</div>
                                            <div className='progress-amount'>{testData[12].completed}%</div>
                                        </div>
                                        <div>
                                                {
                                                    <ProgressBar bgcolor={testData[12].bgcolor} basebgcolor={testData[12].basebgcolor} completed={testData[12].completed} />
                                                }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Row>
                    <Row>
                        <Col className='cardCol' xl={6} lg={6} md={6} sm={6} xs={12}>
                            <div  className='card card-bordered card-full'>
                                <div className='card-inner-group'>
                                    <div className='card-inner'>
                                        <div className='card-title-group'>
                                            <div className='card-title'>
                                                <h6 className='ctitle'>New Customer</h6>
                                            </div>
                                            <div className='card-tool'>
                                                <NavLink to='' className='link'>View All</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        userData.map((user,id)=>(
                                            <div key={id} className='card-inner card-inner-md'>
                                        <div className='user-card'>
                                            <div className='user-avatar bg-primary-dim'>
                                                <span className='avatarclass'>{user.avatar}</span>
                                            </div>
                                            <div className='user-info'>
                                                <span className='lead-text'>{user.name}</span>
                                                <span className='sub-text'>{user.email}</span>
                                            </div>
                                            <div className='user-action'>
                                                <div className='drodown'>
                                                    <NavLink to=''>
                                                        <BsThreeDots />
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        ))
                                    }
                                    

                                    

                                </div>
                            </div>
                        </Col>
                        <Col className='cardCol' xl={6} lg={6} md={6} sm={6} xs={12}>
                            <div  className='card card-bordered card-full'>
                                <div className='card-inner-group'>
                                    <div className='card-inner'>
                                        <div className='card-title-group'>
                                            <div className='card-title'>
                                                <h6 className='ctitle'>Reviews</h6>
                                            </div>
                                            <div className='card-tool'>
                                                <NavLink to='' className='link'>View All</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        reviewData.map((user,id)=>(
                                            <div key={id} className='card-inner card-inner-md'>
                                        <div className='user-card'>
                                            <div className='user-avatar bg-primary-dim'>
                                                <span className='avatarclass'>{user.avatar}</span>
                                            </div>
                                            <div className='user-info'>
                                                <span className='lead-text'>{user.name}</span>
                                                <span className='sub-text'>{user.message}</span>
                                            </div>
                                            <div className='user-action'>
                                                <div className='drodown'>
                                                    <span>
                                                        {
                                                            reviewStars(user.stars)
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        ))
                                    }
                                    

                                    

                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                
            </div>
            
        </div>
    )
}

export default Dashboard
